<template>
  <div id="app">
    <c-header></c-header>
    <div class="wrap">
      <c-menu></c-menu>
        <div class="content wrap-content">
          <router-view></router-view>
        </div>
    </div>
  </div>
</template>

<script>
import cHeader from '../../../components/header.vue'
import cMenu from '../../../components/menu.vue'
import { getAdminInfo } from '../../../api/admin'
import {mapState,mapMutations} from 'vuex'

export default {
  name: 'App',
  components: {
    cHeader,
    cMenu
  },
  data(){
    return{
      menuType: 'admin'
    }
  },
  computed:{
    ...mapState([
      'imgHost',
      'userInfo'
    ])
  },
  mounted() {
      this._getAdminInfo();
  },
  methods:{
    ...mapMutations([
      'setUserInfo'
    ]),
    // 获取用户信息
    _getAdminInfo(){
      getAdminInfo({}).then(res=>{
        if(res && res.pin){
          sessionStorage.setItem('user_identity',res.identity);
          sessionStorage.setItem('user_pin',res.pin);
          this.setUserInfo(res || {});
        }else{
          this.$alert('您没有访问该系统的权限！', '系统提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push({
                path: "/logo",
                query: {
                  returnUrl: window.location.href,
                },
              });
            }
          });

        }
      }).catch(error=>{
        
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  #app {
    /*height:100%;*/
  }
  .wrap{
    position: relative;
    margin-top: 1px;
    /*overflow: hidden;*/

    .cMenu{
      position: absolute;
      top: 0;
      left: 0;
      width: 180px;
      height: 100%;
      z-index: 1;
    }
    .content{
      position: relative;
      padding: 26px 25px 18px 26px;
    }
    .wrap-content{
      margin-left: 180px;
    }
  }
</style>
